export enum PropertyFormat {
  DateTime = 'date-time',
  UUID = 'uuid'
}
